import { h } from '@stencil/core/internal/client';

/**
 * Returns markup for an input label.
 * @internal
 */
const PdsLabel = ({ classNames, htmlFor, text }) => (h("label", { class: classNames, htmlFor: htmlFor }, text));

export { PdsLabel as P };

//# sourceMappingURL=pds-label.js.map